import { render, staticRenderFns } from "./ServiceProfileMenu.vue?vue&type=template&id=36d887da&"
import script from "./ServiceProfileMenu.vue?vue&type=script&lang=js&"
export * from "./ServiceProfileMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports